// src/redux/actions/loginUser.js

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  KYC_REQUIRED,
} from "../types/authTypes";
import { LoginApi, LogoutAPI } from "../../Services/UserServices";
import { toast } from "react-toastify";
import { persistor } from "../store";
import { fetchCart } from "./cartActions";

// Login Action
export const loginUser =
  ({ phone_number, otp }, navigate) =>
  async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });

    try {
      const response = await LoginApi({ phone_number, otp });

      if (response.status === 403) {
        navigate("/vendor-Kyc");
        dispatch({
          type: LOGIN_FAILURE,
          payload: response.data?.message || "Vendor KYC required",
        });
        toast.error("Vendor KYC required. Redirecting...");
        return;
      }
      if (response.status === 200 && response.data?.data) {
        const { access, refresh, user_type, minimum_cart_amount, user } =
          response.data.data;
        localStorage.setItem("access_token", access);
        localStorage.setItem("refresh_token", refresh);
        localStorage.setItem("user_type", user_type);
        // localStorage.setItem('minimum_cart_amount', minimum_cart_amount);
        if (user) localStorage.setItem("user", JSON.stringify(user));

        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            user: user || { user_type },
            minimum_cart_amount: minimum_cart_amount,
          },
        });
        dispatch(fetchCart());
        toast.success("Login successful!");
        navigate("/home");
      } else {
        const msg = response.data?.message || "Login failed";
        dispatch({ type: LOGIN_FAILURE, payload: msg });
        toast.error(msg);
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        navigate("/vendor-Kyc");
        dispatch({
          type: LOGIN_FAILURE,
          payload: err.response.data?.message || "Vendor KYC required",
        });
        toast.error("Vendor KYC required. Redirecting...");
        return;
      }

      const errorMessage =
        err.response?.data?.message || err.message || "An error occurred";
      dispatch({ type: LOGIN_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
    }
  };

// Logout Action
export const logoutUser = () => async (dispatch) => {
  dispatch({ type: LOGOUT_REQUEST });

  // Prevent calling API when no tokens exist
  const access = localStorage.getItem("access_token");
  const refresh = localStorage.getItem("refresh_token");
  if (!access && !refresh) {
    dispatch({ type: LOGOUT_SUCCESS });
    try {
      if (persistor?.purge) await persistor.purge();
    } catch {}
    return;
  }

  try {
    const response = await LogoutAPI();

    if (response.status === 200) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_type");
      localStorage.removeItem("user");

      dispatch({ type: LOGOUT_SUCCESS });
      toast.success(response.data.message || "Logged out successfully");

      if (persistor?.purge) {
        await persistor.purge();
      }
    } else {
      throw new Error(response.data.message || "Logout failed");
    }
  } catch (error) {
    dispatch({
      type: LOGOUT_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    // toast.error(error.response?.data?.message || error.message || "Logout failed");
  } finally {
    // ensure client always clears tokens
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_type");
    localStorage.removeItem("user");
  }
};
